import { header } from 'utils/auth';
import { ensureCsrfToken } from 'utils/csrf';

/** Cookie session (`credentials`) + optional Bearer + CSRF for mutating requests. */
export async function authenticatedFetch(
  input: RequestInfo,
  init: RequestInit = {},
): Promise<Response> {
  const method = String(init.method || 'GET').toUpperCase();
  const headers = new Headers(init.headers);
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    try {
      const csrf = await ensureCsrfToken();
      if (csrf) headers.set('X-CSRF-Token', csrf);
    } catch (e) {
      console.warn('authenticatedFetch CSRF', e);
    }
  }
  const auth = header();
  if (auth) {
    headers.set('Authorization', auth);
  }
  return fetch(input, {
    ...init,
    credentials: 'include',
    headers,
  });
}
